/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BarChart, LineChart, PieChart} from '../../../components/Charts';
export const franceGeneralData = {
  population: '67.81 million',
  laborForce: '27.73 million (2021)',
  unemploymentRate: '7.4%',
  gdpPerCapita: '32,530 euros'
};
export const euEconomyComparison = [{
  name: 'France GDP',
  value: 17
}, {
  name: 'Germany GDP',
  value: 25.1
}, {
  name: 'Rest of EU',
  value: 57.9
}];
export const euIncomeRanking = [{
  name: 'Luxembourg',
  value: 42200
}, {
  name: 'Norway',
  value: 35600
}, {
  name: 'Switzerland',
  value: 33800
}, {
  name: 'Denmark',
  value: 28900
}, {
  name: 'Austria',
  value: 27800
}, {
  name: 'France',
  value: 26200
}, {
  name: 'Germany',
  value: 25900
}, {
  name: 'Belgium',
  value: 25100
}];
export const clothingSpendingComparison = [{
  name: 'France 2020',
  value: 430
}, {
  name: 'EU-27 Average 2020',
  value: 490
}, {
  name: 'France 2018',
  value: 530
}];
export const europeanClothingSpending2018 = [{
  name: 'United Kingdom',
  value: 65.4
}, {
  name: 'Germany',
  value: 62.7
}, {
  name: 'Italy',
  value: 52.4
}, {
  name: 'France',
  value: 35.7
}, {
  name: 'Spain',
  value: 28.1
}];
export const fashionTurnoverBreakdown = [{
  name: 'Textiles/Clothing',
  value: 66.3
}, {
  name: 'Perfumes',
  value: 46.4
}, {
  name: 'Shoes and leather',
  value: 21.2
}, {
  name: 'Eyewear',
  value: 8.7
}, {
  name: 'Watches/Jewellery',
  value: 7.3
}, {
  name: 'Related services',
  value: 4.2
}];
export const directSalesShare = [{
  name: 'Retail sales',
  value: 49
}, {
  name: 'Manufacturing',
  value: 26
}, {
  name: 'Wholesale',
  value: 22
}, {
  name: 'Associated services',
  value: 3
}];
export const fashionEconomicContribution = [{
  name: 'Direct value added',
  value: 37.5,
  jobs: 617
}, {
  name: 'Induced effects',
  value: 10.2,
  jobs: 115
}, {
  name: 'Indirect effects',
  value: 21.2,
  jobs: 277
}];
export const euClothingImports2020 = [{
  name: 'Germany',
  value: 17
}, {
  name: 'Spain',
  value: 10
}, {
  name: 'France',
  value: 10
}, {
  name: 'Italy',
  value: 8.5
}, {
  name: 'Netherlands',
  value: 7.2
}];
export const euClothingExports2020 = [{
  name: 'Italy',
  value: 6.8
}, {
  name: 'Germany',
  value: 5.2
}, {
  name: 'Spain',
  value: 4.5
}, {
  name: 'France',
  value: 4.0
}, {
  name: 'Netherlands',
  value: 3.8
}];
export const frenchLuxuryBrands = [{
  name: 'Louis Vuitton',
  value: 20.2
}, {
  name: 'Chanel',
  value: 13.16
}, {
  name: 'Hermes',
  value: 11.64
}, {
  name: 'Cartier',
  value: 10.71
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    strong: "strong",
    h3: "h3",
    p: "p",
    em: "em"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "General data"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Metric"
          }), _jsx(_components.th, {
            children: "Value"
          }), _jsx(_components.th, {
            children: "Source"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Population:"
            })
          }), _jsx(_components.td, {
            children: "67.81 million"
          }), _jsx(_components.td, {
            children: "INSEE, September 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Labor force:"
            })
          }), _jsx(_components.td, {
            children: "27.73 billion (in 2021)"
          }), _jsx(_components.td, {
            children: "Informations sur le marché du travail : site Internet de la Commission européenne de la France, Septembre 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Unemployment rate:"
            })
          }), _jsx(_components.td, {
            children: "7.4%"
          }), _jsx(_components.td, {
            children: "INSEE, September 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Real GDP per capita:"
            })
          }), _jsx(_components.td, {
            children: "32 530 euros"
          }), _jsx(_components.td, {
            children: "Eurostat, September 2022"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "France: Economy, household income and purchasing power"
    }), "\n", _jsx(_components.h3, {
      children: "Economy"
    }), "\n", _jsx(_components.p, {
      children: "France is the seventh largest economy in the world and the second largest in the European Union, after Germany (see the EU tab for more information)."
    }), "\n", _jsx(_components.p, {
      children: "Its GDP of 2.3 trillion euros represents 17% of the total GDP of the EU-27."
    }), "\n", _jsx(PieChart, {
      data: euEconomyComparison,
      title: "France Share of EU-27 GDP (%)",
      dataKey: "value",
      xAxisKey: "name",
      valueSuffix: "%"
    }), "\n", _jsx(_components.p, {
      children: "Source: Publication of the Commissioner for Trade in France: Market Panorama, based on Eurostat information, in May 2020"
    }), "\n", _jsx(_components.p, {
      children: "Gross Domestic Product (GDP) in France per capita in 2020: 34,000 euros (just above the EU average of 29,700 euros)."
    }), "\n", _jsx(_components.p, {
      children: "Source: CBS publication in July 2021 based on Eurostat information"
    }), "\n", _jsx(_components.h3, {
      children: "Household income and purchasing power"
    }), "\n", _jsx(_components.p, {
      children: "Household disposable income per capita in France, adjusted for price levels, was 26,200 euros per capita in 2019. France ranks sixth in the EU."
    }), "\n", _jsx(BarChart, {
      data: euIncomeRanking,
      title: "EU Household Disposable Income per Capita (euros, 2019)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: publication of the CBS in a July 2021 paper based on Eurostat information (adjusted gross disposable household income per capita in PPS)"
    }), "\n", _jsx(_components.p, {
      children: "France had an average purchasing power of 20,306 euros per capita for spending and saving in 2019, 38% higher than the EU average of 14,739 euros."
    }), "\n", _jsx(_components.p, {
      children: "Source: GfK Purchasing Power Europe 2019, October 2019."
    }), "\n", _jsx(_components.h2, {
      children: "Clothing consumption and household expenditure"
    }), "\n", _jsx(_components.h3, {
      children: "Clothing consumption expenditure in France: how much do the French spend on clothing?"
    }), "\n", _jsx(_components.p, {
      children: "Household spending on clothing and footwear in 2020 was 3.1% (as % of total expenditure)."
    }), "\n", _jsx(_components.p, {
      children: "Source: Household expenditure by category, France, 2020, Clothing and Footwear (as % of total expenditure), Eurostat"
    }), "\n", _jsx(_components.p, {
      children: "In 2020, the French spent an average of 430 euros on clothing. Consumer spending on fashion is lower than the EU-27 average of 490 euros."
    }), "\n", _jsx(BarChart, {
      data: clothingSpendingComparison,
      title: "French Clothing Spending vs EU Average (euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€"
    }), "\n", _jsx(_components.p, {
      children: "From the Key Facts and Figures 2022 of the Euratex European Textile and Clothing Industry report, June 2022. Source: Eurostat"
    }), "\n", _jsx(_components.p, {
      children: "In 2018, the French spent 35.7 billion euros on clothing and footwear, making them the fourth biggest spenders in Europe, after the UK, Germany and Italy."
    }), "\n", _jsx(BarChart, {
      data: europeanClothingSpending2018,
      title: "European Clothing Spending 2018 (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: Household consumption expenditure on clothing in the European Union in 2018, by country, Statista 2022"
    }), "\n", _jsx(_components.p, {
      children: "The French purchased 1.5 billion units of clothing in 2017. In that year, France was the ninth largest retail market in the world."
    }), "\n", _jsx(_components.p, {
      children: "Source: Common Objective CO Data in the article 'Volume and Consumption: How much does the world buy?', May 2018. Based on data: Number of apparel units purchased per country, 2017 (Source: Market Research Provider, Euromonitor International)"
    }), "\n", _jsx(_components.h2, {
      children: "Overview of fashion in France"
    }), "\n", _jsx(_components.p, {
      children: "Direct turnover: 154 billion euros\nExport turnover: 35.7 billion euros\nAdded value: 37.5 billion euros (1.7% of GDP)\nNumber of jobs in the sector: 616,552"
    }), "\n", _jsx(_components.p, {
      children: "From 'Fashion in France : Evaluation of its economic weight', Institut Francais de la Mode, November 2018. Sources: INSEE, ESANE 2016."
    }), "\n", _jsx(_components.h3, {
      children: "Turnover"
    }), "\n", _jsx(_components.p, {
      children: "The direct turnover of the fashion industry is 154 billion euros."
    }), "\n", _jsx(BarChart, {
      data: fashionTurnoverBreakdown,
      title: "French Fashion Industry Turnover by Sector (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "From \"La Mode en France : Evaluation de son poids économique\", carried out by the Institut Français de la Mode and Quadrat Etudes with the support of DEFI, November 2018. Sources: INSEE, ESANE 2016."
    }), "\n", _jsx(_components.h3, {
      children: "Share in direct sales"
    }), "\n", _jsx(PieChart, {
      data: directSalesShare,
      title: "Fashion Industry Direct Sales Share (%)",
      dataKey: "value",
      xAxisKey: "name",
      valueSuffix: "%"
    }), "\n", _jsx(_components.h2, {
      children: "Fashion in France is a major contributor to GDP and employment"
    }), "\n", _jsx(_components.p, {
      children: "Fashion contributes directly 37.5 billion euros and indirectly 31.4 billion euros to a total of 68.9 billion euros of added value, or 3.1% of French GDP."
    }), "\n", _jsx(_components.p, {
      children: "In terms of jobs, fashion contributes directly 616,000 and indirectly 384,000 for a total of 1 million jobs in France."
    }), "\n", _jsx(BarChart, {
      data: fashionEconomicContribution,
      title: "Fashion Economic Contribution (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B"
    }), "\n", _jsx(_components.p, {
      children: "From \"La Mode en France : Evaluation de son poids économique\", carried out by the Institut Français de la Mode and Quadrat Etudes with the support of DEFI, November 2018."
    }), "\n", _jsx(_components.h2, {
      children: "French industries"
    }), "\n", _jsx(_components.p, {
      children: "With 2,500 companies, the French clothing industry employs 32,000 people in France and more than 300,000 abroad."
    }), "\n", _jsx(_components.p, {
      children: "Turnover of the French clothing industry is 15 billion euros, of which 8.7 billion euros, or 58%, is generated internationally."
    }), "\n", _jsx(_components.p, {
      children: "Source: Union Française des Industries Mode & Habillement"
    }), "\n", _jsx(_components.h2, {
      children: "French manufacturing"
    }), "\n", _jsx(_components.p, {
      children: "French manufacturing today"
    }), "\n", _jsx(_components.p, {
      children: "450 companies\n11,000 jobs\nLuxury represents 400 companies and 9500 jobs"
    }), "\n", _jsx(_components.p, {
      children: "Source: Union Française des Industries Mode & Habillement"
    }), "\n", _jsx(_components.h2, {
      children: "Import and Export"
    }), "\n", _jsx(_components.h3, {
      children: "France is the third largest importer of clothing in the EU and the fourth largest exporter of clothing in the EU."
    }), "\n", _jsx(_components.p, {
      children: "In 2020, France imported almost 10 billion items of clothing. This makes France the third largest importer of clothing in Europe after Germany, which is the largest importer of clothing with 17 billion, followed by Spain with 10 billion."
    }), "\n", _jsx(BarChart, {
      data: euClothingImports2020,
      title: "EU Clothing Imports 2020 (billions of items)",
      dataKey: "value",
      xAxisKey: "name",
      valueSuffix: "B"
    }), "\n", _jsx(_components.p, {
      children: "France is the fourth largest exporter of clothing in the EU, after Italy, Germany and Spain. France exported almost 4 billion items of clothing in 2020."
    }), "\n", _jsx(BarChart, {
      data: euClothingExports2020,
      title: "EU Clothing Exports 2020 (billions of items)",
      dataKey: "value",
      xAxisKey: "name",
      valueSuffix: "B"
    }), "\n", _jsx(_components.p, {
      children: "Source: Eurostat news 'Where do our clothes come from', April 2021."
    }), "\n", _jsx(_components.h3, {
      children: "Trade FR EU"
    }), "\n", _jsx(_components.p, {
      children: "In 2020, EU imports of clothing increased by 12% compared to 2019 (+66% for textiles)."
    }), "\n", _jsx(_components.p, {
      children: "Exports decreased by 12% for clothing and 14% for textiles, compared to 2019."
    }), "\n", _jsx(_components.p, {
      children: "Source: Institut Francais de la Mode, 'EU External Trade : January - December 2020 from February 2021"
    }), "\n", _jsx(_components.h3, {
      children: "Import UE-28 2020"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Clothing"
          }), _jsx(_components.th, {
            children: "IEU 28 IMPORTS IN THE PERIOD JANUARY - DECEMBER 2020 In millions of euros"
          }), _jsx(_components.th, {
            children: "% Variation 2020/ 2019"
          })]
        })
      }), _jsx(_components.tbody, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Total"
          }), _jsx(_components.td, {
            children: "77 351 526"
          }), _jsx(_components.td, {
            children: "-12%"
          })]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "Clothing is mainly imported from Asia (59 219 995 million euros in 2020).\nMain importing countries: China (1), Bangladesh, Turkey, India, Vietnam, Cambodia, Pakistan, Myanmar, Morocco and Tunisia."
    }), "\n", _jsx(_components.p, {
      children: "Issu de l'Institut Francais de la Mode, February 2021. Importations UE 28 Sur la période Janvier - Décembre 2020 en milliers d'euros. Source: TDM, Calculs IFM."
    }), "\n", _jsx(_components.h3, {
      children: "Export EU-28 2020"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Clothing"
          }), _jsx(_components.th, {
            children: "IEU 28 EXPORTS IN THE PERIOD JANUARY - DECEMBER 2020 In millions of euros"
          }), _jsx(_components.th, {
            children: "% Variation 2020/ 2019"
          })]
        })
      }), _jsx(_components.tbody, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Total"
          }), _jsx(_components.td, {
            children: "25 513 304"
          }), _jsx(_components.td, {
            children: "-12%"
          })]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "Main exporting countries: Switzerland, the United States, Russia, China, Hong Kong, Japan, South Korea, Norway, Australia and Turkey."
    }), "\n", _jsx(_components.p, {
      children: "Issu de l'Institut Francais de la Mode, February 2021. Exportations UE 28 Sur la periode Janvier - Décembre 2020 en milliers d'euros. Source: TDM, Calculs IFM."
    }), "\n", _jsx(_components.h3, {
      children: "Trade partners in textiles and clothing"
    }), "\n", _jsx(_components.p, {
      children: "In 2019, France's main textile and clothing trading partners were Italy, Spain, Germany, Belgium and the UK for exports. For imports, its main partners were China, Bangladesh, Italy, Turkey and India for imports."
    }), "\n", _jsx(_components.p, {
      children: "Source: WITS World bank France Textiles and Clothing Exports, Imports, Tariffs by country and region 2019"
    }), "\n", _jsx(_components.h2, {
      children: "The largest French fashion companies"
    }), "\n", _jsx(_components.h3, {
      children: "LVMH Group is the world's leading apparel company by market capitalisation (2022)"
    }), "\n", _jsx(_components.p, {
      children: "LVMH is by far the fashion company with the highest market capitalization, valued at around $317 billion in September 2022. This is over $150 billion more than Nike, which is in second place with a market capitalisation of $163.1 billion. Dior comes in third place. The market capitalization value of LVMH was roughly equal to that of the seven companies ranked fourth to tenth, according to market and consumer data firm Statista."
    }), "\n", _jsx(_components.p, {
      children: "Source: Leading clothing companies worldwide as of September 2022, by market capitalization, in billion US dollars September 2022"
    }), "\n", _jsx(_components.p, {
      children: "According to Forbes, Louis Vuitton is the 9th most valuable fashion brand in the world, with a brand value of $47.2 billion."
    }), "\n", _jsx(_components.h3, {
      children: "The most prestigious French brands in the world: Louis Vuitton, Chanel, Hermès and Cartier"
    }), "\n", _jsx(_components.p, {
      children: "According to Statista, France has the sixth highest national brand value in the world in 2021."
    }), "\n", _jsx(_components.p, {
      children: "Louis Vuitton is the most valuable French brand in the world, worth 20.2 billion euros. Also in the top 10 most valuable French brands in the world (2022) are Chanel, Hermès and Cartier."
    }), "\n", _jsx(BarChart, {
      data: frenchLuxuryBrands,
      title: "Most Valuable French Fashion Brands 2022 (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: Most valuable French brands in the world in 2022, by brand value (in billion euros) Statista, August 2022"
    }), "\n", _jsx(_components.p, {
      children: "In Q1 2022 Louis Vuitton was the third most fashionable brand, according to the Lyst Index (Q1 2022)."
    }), "\n", _jsx(_components.h2, {
      children: "E-commerce"
    }), "\n", _jsx(_components.h3, {
      children: "E-commerce in France in 2021: the French spent 129 billion euros online"
    }), "\n", _jsx(_components.p, {
      children: "In 2021, the Covid-19 pandemic pushed the French to buy more online (one online purchase per buyer per week on average in 2021). Average purchase value: 60 euros."
    }), "\n", _jsx(_components.p, {
      children: "Source: Rapport Chiffres clés du e-commerce 2022, Fevad."
    }), "\n", _jsx(_components.p, {
      children: "The e-commerce sector (products and services) exceeded 129 billion euros in 2021, an increase of 15.1% compared to 8.5% in 2020. The fashion-clothing category continued to grow in 2021 with +6%."
    }), "\n", _jsx(_components.p, {
      children: "Source: Press release Fevad (Federation of e-commerce and distance selling), February 2022"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Last update: October 2022"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
